import { debounce } from "lodash";
import { useRef, useCallback, useState, createContext } from "react";
import { CenterService } from "../services/CenterService";

export const CenterContext = createContext();

export const CenterProvider = ({ children }) => {
  const [centerData, setCenterData] = useState([]);
  const currentRequest = useRef(null);

  const searchCenter = async (query) => {
    if (!query) {
      setCenterData([]);
      return;
    }

    // 이전 요청 취소
    if (currentRequest.current) {
      currentRequest.current.abort();
    }

    // 새로운 요청 생성
    const controller = new AbortController();
    currentRequest.current = controller;

    try {
      const data = await CenterService.searchCenter(query, { signal: controller.signal });

      // 최신 요청의 응답인지 확인
      if (controller === currentRequest.current) {
        setCenterData(data || []);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error searching center data:", error);
      }
    }
  };

  const fetchCenters = async (siggId) => {
    try {
      const response = await CenterService.fetchCenter(siggId);
      setCenterData(response);
    } catch (error) {
      console.error("Error fetching centers:", error);
    }
  }

  // 💡 300ms 동안 입력이 없으면 검색 실행
  const debouncedSearchCenter = useCallback(debounce(searchCenter, 300), []);

  return (
    <CenterContext.Provider value={{ centerData, fetchCenterBySiggs: fetchCenters, searchCenterByTitle: debouncedSearchCenter }}>
      {children}
    </CenterContext.Provider>
  );
};
